import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-field-group" }
const _hoisted_2 = {
  class: "grid",
  "data-layout": "halves"
}

import type { Salutation } from '@src/view_models/Salutation';
import type { AddressFormData, AddressValidity } from '@src/view_models/Address';
import RadioField from '@src/components/shared/form_fields/RadioField.vue';
import SelectField from '@src/components/shared/form_fields/SelectField.vue';
import TextField from '@src/components/shared/form_fields/TextField.vue';
import type { CheckboxFormOption } from '@src/components/shared/form_fields/FormOptions';

interface Props {
	salutations: Salutation[];
	formData: AddressFormData;
	showError: AddressValidity;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NameFields',
  props: {
    salutations: {},
    formData: {},
    showError: {}
  },
  emits: [ 'field-changed' ],
  setup(__props: any) {


const props = __props;


const salutationFormOptions: CheckboxFormOption[] = props.salutations.map( ( x, index ) => (
	{ value: x.value, label: x.label, id: `salutation-${ index }` }
) );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RadioField, {
        name: "salutation",
        id: "address-form-salutation",
        modelValue: __props.formData.salutation.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.formData.salutation.value) = $event)),
        label: _ctx.$t( 'donation_form_salutation_label' ),
        options: _unref(salutationFormOptions),
        "show-error": __props.showError.salutation,
        "error-message": _ctx.$t( 'donation_form_salutation_error' ),
        layoutType: "cluster",
        onFieldChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('field-changed', 'salutation')))
      }, null, 8, ["modelValue", "label", "options", "show-error", "error-message"]),
      _createVNode(SelectField, {
        name: "title",
        modelValue: __props.formData.title.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.formData.title.value) = $event)),
        id: "address-form-title",
        class: "flex-field-group__stretch",
        "input-id": "title",
        label: _ctx.$t( 'donation_form_academic_title_label' ),
        options: [
				{ label: _ctx.$t( 'donation_form_academic_title_option_none' ), value: '' },
				{ label: 'Dr.', value: 'Dr.' },
				{ label: 'Prof.', value: 'Prof.' },
				{ label: 'Prof. Dr.', value: 'Prof. Dr.' },
			],
        onFieldChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('field-changed', 'title')))
      }, null, 8, ["modelValue", "label", "options"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextField, {
        name: "firstName",
        id: "address-form-first-name",
        "input-id": "first-name",
        modelValue: __props.formData.firstName.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.formData.firstName.value) = $event)),
        "show-error": __props.showError.firstName,
        "error-message": _ctx.$t( 'donation_form_firstname_error' ),
        autocomplete: "given-name",
        label: _ctx.$t( 'donation_form_firstname_label' ),
        placeholder: _ctx.$t( 'donation_form_firstname_placeholder' ),
        onFieldChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('field-changed', 'firstName')))
      }, null, 8, ["modelValue", "show-error", "error-message", "label", "placeholder"]),
      _createVNode(TextField, {
        name: "lastName",
        id: "address-form-last-name",
        "input-id": "last-name",
        modelValue: __props.formData.lastName.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.formData.lastName.value) = $event)),
        "show-error": __props.showError.lastName,
        "error-message": _ctx.$t( 'donation_form_lastname_error' ),
        autocomplete: "family-name",
        label: _ctx.$t( 'donation_form_lastname_label' ),
        placeholder: _ctx.$t( 'donation_form_lastname_placeholder' ),
        "placeholder-warning": "donation_form_lastname_placeholder_warning",
        onFieldChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('field-changed', 'lastName')))
      }, null, 8, ["modelValue", "show-error", "error-message", "label", "placeholder"])
    ])
  ], 64))
}
}

})